import { render, staticRenderFns } from "./PendenciasDeLogin.vue?vue&type=template&id=ac63fc22"
import script from "./PendenciasDeLogin.vue?vue&type=script&lang=js"
export * from "./PendenciasDeLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports